const websiteRoutes = [
  'home.workspace',
  'home.workspace.article',
  'home.community',
  'home.community.article',
  'home.company.about',
  'home.company.story',
  'home.company.careers',
  'home.pricing',
  'home.formats',
];

export default websiteRoutes;
